import { render, staticRenderFns } from "./shop-detail.vue?vue&type=template&id=6319c1b2"
import script from "./shop-detail.vue?vue&type=script&lang=js"
export * from "./shop-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports